import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex min-h-[50vh] max-w-lg flex-col items-center justify-center px-5 py-20 text-center">
      <h2 className="mb-2 text-xl font-semibold text-[#003f28] md:text-2xl">Página no encontrada</h2>
      <p className="mb-6 text-base text-[#00402a]/70">La ruta solicitada no existe.</p>
      <Link
        to="/"
        className="rounded-full bg-[#ffa61c] px-6 py-3 text-base font-semibold text-[#003f28] transition hover:scale-[1.02]"
      >
        Volver al inicio
      </Link>
    </div>
  );
}
